import { api } from "@/api/client";

// Shapes mirror PaymentSyncBatchSerializer. Money is sent as decimal strings.

export type PsMilestone = "deposit" | "sop" | "final";
export type PsRowStatus = "pending" | "posted" | "excluded" | "skipped" | "failed";
export type PsBatchStatus = "open" | "posting" | "posted" | "superseded";

export interface PsRow {
  id: number;
  ns_transaction_id: number;
  ns_type: string;
  ns_label: string;
  ns_date: string | null;
  amount: string | null;
  memo: string | null;
  project_id: string | null;
  customer_name: string | null;
  action: "check" | "uncheck";
  milestone: PsMilestone | null;
  task_name: string | null;
  sunrise_state: string | null;
  state_label: string;
  so_balance: string | null;
  flags: string[];
  flag_labels: string[];
  selected: boolean;
  selectable: boolean;
  status: PsRowStatus;
  error: string | null;
  posted_by: string | null;
  posted_at: string | null;
  netsuite_url: string | null;
  sunrise_url: string | null;
}

export interface PsBatch {
  id: number;
  run_on: string;
  status: PsBatchStatus;
  built_at: string | null;
  emailed_at: string | null;
  posted_by: string | null;
  posted_at: string | null;
  error: string | null;
  row_count: number;
  current: boolean;
  rows?: PsRow[];
}

export interface PsPage {
  batch: PsBatch | null;
  history: PsBatch[];
  write_enabled: boolean;
  can_post: boolean;
  can_rebuild: boolean;
  guide_url: string;
  tasks: { milestone: PsMilestone; task: string }[];
}

export interface PsSelection {
  id: number;
  selected: boolean;
  milestone: PsMilestone | "";
}

export async function fetchPaymentSync(batchId?: string): Promise<PsPage> {
  const { data } = await api.get<PsPage>(batchId ? `/payment_syncs/${batchId}` : "/payment_syncs");
  return data;
}

export async function postPaymentSyncBatch(id: number, rows: PsSelection[]): Promise<PsPage> {
  const { data } = await api.post<PsPage>(`/payment_syncs/${id}/post_batch`, { rows });
  return data;
}

export async function rebuildPaymentSync(): Promise<{ queued: boolean; current_batch_id: number | null }> {
  const { data } = await api.post<{ queued: boolean; current_batch_id: number | null }>("/payment_syncs/rebuild");
  return data;
}
